
export default function AboutSection() {
  return (
    <section 
      id="about" 
      className="py-20 relative bg-cover bg-center bg-no-repeat min-h-screen flex items-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.3)), url('https://static.readdy.ai/image/40b0e54abc8a92bbb8d049c8a84106ef/2a3866bfe73b4ad3917f1fbbaf426b14.jpeg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-6 w-full">
        <div className="max-w-4xl">
          {/* Left Content */}
          <div className="text-white">
            <h2 className="text-4xl lg:text-5xl font-bold mb-8">
              Who We Are
            </h2>
            
            <p className="text-lg text-gray-100 mb-8 leading-relaxed">
              Golden Twin Towers Ltd. is a UK-based trading and brand management company dedicated to expanding Korean beauty excellence across the world. We provide strategic distribution, manufacturing coordination, and regulatory expertise to help brands and retailers thrive globally.
            </p>
            
            <div className="bg-white/10 backdrop-blur-sm border-l-4 border-[#C8A654] p-6 mb-8 rounded-lg">
              <h3 className="text-xl font-semibold text-white mb-3">Our Mission</h3>
              <p className="text-lg text-gray-100 italic">
                "To empower beauty brands through trusted partnerships, compliance, and innovation."
              </p>
            </div>

            {/* Key Features */}
            <div className="space-y-4 mb-8">
              <div className="flex items-center">
                <div className="w-8 h-8 bg-[#C8A654] rounded-full flex items-center justify-center mr-4">
                  <i className="ri-check-line text-white"></i>
                </div>
                <span className="text-lg text-gray-100">Global distribution network</span>
              </div>
              <div className="flex items-center">
                <div className="w-8 h-8 bg-[#C8A654] rounded-full flex items-center justify-center mr-4">
                  <i className="ri-check-line text-white"></i>
                </div>
                <span className="text-lg text-gray-100">Regulatory compliance expertise</span>
              </div>
              <div className="flex items-center">
                <div className="w-8 h-8 bg-[#C8A654] rounded-full flex items-center justify-center mr-4">
                  <i className="ri-check-line text-white"></i>
                </div>
                <span className="text-lg text-gray-100">Premium OEM/ODM services</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
